var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.config.title,
        modal: true,
        visible: _vm.dialogVisible,
        width: _vm.config.width,
        "append-to-body": true,
        "before-close": _vm.handleClose,
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "mt15",
          attrs: {
            model: _vm.ruleForm,
            rules: _vm.rules,
            "label-width": "90px",
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("hr.jobtitle") + "：", prop: "name" } },
            [
              _c("el-input", {
                attrs: {
                  size: "small",
                  type: "text",
                  placeholder: _vm.$t("hr.message"),
                },
                model: {
                  value: _vm.ruleForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "name", $$v)
                  },
                  expression: "ruleForm.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: "职级类别：", prop: "cateId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: "请选择职级类别",
                  },
                  on: { change: _vm.handleCate },
                  model: {
                    value: _vm.ruleForm.cateId,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "cateId", $$v)
                    },
                    expression: "ruleForm.cateId",
                  },
                },
                _vm._l(_vm.options, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            { attrs: { label: _vm.$t("hr.rank") + "：", prop: "rankId" } },
            [
              _c(
                "el-select",
                {
                  attrs: {
                    size: "small",
                    clearable: "",
                    placeholder: _vm.$t("hr.message9"),
                  },
                  model: {
                    value: _vm.ruleForm.rankId,
                    callback: function ($$v) {
                      _vm.$set(_vm.ruleForm, "rankId", $$v)
                    },
                    expression: "ruleForm.rankId",
                  },
                },
                _vm._l(_vm.rankData, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: { label: item.label, value: item.value },
                  })
                }),
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleClose } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "mr20",
              attrs: { size: "small", loading: _vm.loading, type: "primary" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("public.ok")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }